import styled from 'styled-components';

export const Heading = styled.h1`
text-align: center;
color: green;
`;

export const Content = styled.div`
overflowY: scroll;
height: 2500px;
`;

export const Button = styled.div`
position: fixed;
width: 100%;
bottom: 40px;
height: 20px;
font-size: 35px;
z-index: 1000;
text-align: right;
padding-right: 15px;
`
